// External Libraries
import React from 'react';
import type { ReactElement } from 'react';

// Internal Libraries
import { features, useMountLogging } from '@/lib';
import { AccountBenefits } from '@/components/CheckoutIncentives/AccountBenefits';
import { PurchaseProtectionV2 } from '@/components/CheckoutIncentives/PurchaseProtection';
import { StretchRewards } from '@/components/CheckoutIncentives/StretchRewards';

type ExpandedValuePropsParams = {
  toggleComponent?: JSX.Element; // Optional, as we use this component for forced signup as well.
};

const ExpandedValueProps = ({
  toggleComponent,
}: ExpandedValuePropsParams): ReactElement => {
  useMountLogging('ExpandedValueProps');
  /* We can expect only one of these features to be active due to hire up gating.
     - StreamlineOnboardOptions, Form/Components */
  const isExpandedPurchaseProtection = features.isActive(
    'isExpandedPurchaseProtection',
  );
  const isStretchRewards = features.isActive('isExpandedStretchRewards');
  const isExpandedBenefits = features.isActive('isExpandedRewards');

  return (
    <div data-testid="expanded-value-props">
      {isExpandedPurchaseProtection && (
        <PurchaseProtectionV2 toggleComponent={toggleComponent} />
      )}
      {isStretchRewards && <StretchRewards toggleComponent={toggleComponent} />}
      {isExpandedBenefits && (
        <AccountBenefits toggleComponent={toggleComponent} />
      )}
    </div>
  );
};

export { ExpandedValueProps };
